const custNameAlgoEstimationShow = (custName: string) => {
  const prefixCustName: string[] = ["Bukalapak", "Tokopedia"];
  return prefixCustName.includes(custName);
};
export default custNameAlgoEstimationShow;
